import React from 'react';
import {Box, MenuItem, TextField, Typography} from '@material-ui/core';
import {ICustomerSupportFormProps} from './AddNewDataPointForm.types';

export const CustomerSupportForm: React.FC<ICustomerSupportFormProps> = ({
  data,
  onDataChange,
}) => {
  const handleChange = (field: string, value: any) => {
    onDataChange({...data, [field]: value});
  };

  return (
    <>
      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Subject
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Enter ticket subject"
          value={data.subject || ''}
          onChange={(e) => handleChange('subject', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Description
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          size="small"
          placeholder="Describe the support request"
          value={data.description || ''}
          onChange={(e) => handleChange('description', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Priority
        </Typography>
        <TextField
          select
          fullWidth
          variant="outlined"
          size="small"
          value={data.priority || 'medium'}
          onChange={(e) => handleChange('priority', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        >
          <MenuItem value="low">Low</MenuItem>
          <MenuItem value="medium">Medium</MenuItem>
          <MenuItem value="high">High</MenuItem>
        </TextField>
      </Box>
    </>
  );
};
